import __var_0__ from '@stdlib/assert/is-function';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isFunction = __var_0__;


// MAIN //

/**
* Sets the x-value accessor.
*
* @private
* @param {Function} fcn - accessor function
* @throws {TypeError} must be a function
*/
function setXValue( fcn ) {
	/* eslint-disable no-invalid-this */
	if ( !isFunction( fcn ) ) {
		throw new TypeError( 'invalid value. `xValue` must be a function. Value: `' + fcn + '`.' );
	}
	this._xValue = fcn;
}


// EXPORTS //
export default setXValue;
